import { StrictMode, useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import LeadCaptureForm from './components/LeadCaptureForm.tsx';
import './index.css';

function Root() {
  const [currentPath, setCurrentPath] = useState(() =>
    window.location.pathname.toLowerCase().replace(/\/+$/, '') || '/'
  );

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname.toLowerCase().replace(/\/+$/, '') || '/');
    };
    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  if (currentPath === '/lead-form' || currentPath.startsWith('/lead-form/')) {
    return <LeadCaptureForm />;
  }

  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);

